import { ComponentRenderHooks } from "@launchos/plugins/types";
import LiveContainer from "./component";

export const onComponentRender = (hook, payload, actions) => {
  if (hook.id === ComponentRenderHooks.WEBCOMPONENT && payload.type === "Container") {
    return [LiveContainer];
  }
};
